import clsx from "clsx";
import React from "react";

import { Icon } from "../Icon";
import { Icons } from "../Icon/utils";

export default function Header({
  avatar,
  borderLess,
  description,
  className = "",
  leftActions,
  icon,
  rightActions,
  title,
}: {
  avatar?: React.ReactNode;
  borderLess?: boolean;
  className?: string;
  description?: string;
  icon?: keyof typeof Icons;
  leftActions?: React.ReactNode;
  rightActions?: React.ReactNode;
  title: string;
}) {
  return (
    <div
      className={clsx(
        "flex items-center justify-between px-4 py-3",
        !borderLess && "border-b mb-3 border-gray-200",
        className,
      )}
    >
      <div className="flex gap-2">
        {leftActions && (
          <div className="flex justify-center items-center gap-2">
            {leftActions}
          </div>
        )}
        <div className="flex items-center gap-3">
          {avatar
            ? avatar
            : icon && <Icon name={icon} className="h-4 lg:h-6 text-gray-700" />}
          <div className="flex items-start flex-col ">
            <h2 className="text-md md:text-lg lg:text-xl font-semibold text-gray-700">
              {title}
            </h2>
            <p className="text-xs md:text-sm text-gray-400">{description}</p>
          </div>
        </div>
      </div>
      {rightActions && (
        <div className="flex justify-center gap-2 items-center">
          {rightActions}
        </div>
      )}
    </div>
  );
}
